// Components/TokenRefreshWarning.js
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { useErrorToast } from "./hooks/useErrorToast";

const TokenRefreshWarning = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
const showError = useErrorToast();

  useEffect(() => {
    const hasRefreshToken = !!localStorage.getItem("refreshTokenInv");
    if (open && hasRefreshToken) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [open]);

  const handleRefreshToken = async () => {
    setLoading(true);
    const refreshToken = localStorage.getItem("refreshTokenInv");

    if (!refreshToken) {
      toast.error("Refresh token is missing. Please log in again.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/token/refresh`,
        {},
        {
          headers: {
            Authorization: `Bearer ${refreshToken}`,
          },
        }
      );

      if (response.data?.status) {
        const newAccessToken = response.data.data?.access_token;
        localStorage.setItem("tokenInv", newAccessToken);
        // localStorage.removeItem("refreshTokenInv");
        toast.success("Token refreshed successfully.");
        setShowModal(false);
        onClose();
      } else {
        toast.error("Failed to refresh token.");
      }
    } catch (err) {
      console.error("Error refreshing token:", err);
      // toast.error("Something went wrong. Please try again.");
       showError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={showModal} onClose={onClose}>
        <DialogTitle>Session Expiring Soon</DialogTitle>
        <DialogContent>
          <Typography>
            Your session is about to expire. Please refresh your token to continue using the app.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{setShowModal(false)}} color="secondary" disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleRefreshToken}
            variant="contained"
            color="primary"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Refresh Token"}
          </Button>
        </DialogActions>
      </Dialog>

      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
};

export default TokenRefreshWarning;
